import React from 'react'
import PropTypes from 'prop-types'
import {
  RootWrapper,
  ModalTitle,
  ModalParagraph,
  WarningText,
  CheckWrapper,
  CancelButton,
  DeleteAccountButton,
  ButtonContainer,
} from './DeleteAccountModalContent.styles'

export const DeleteAccountModalContent = ({
  clientEmail,
  onCloseModal,
  onDeleteAccount,
  onCheck,
  checked,
}) => {
  return (
    <RootWrapper>
      <ModalTitle>Delete Client Account</ModalTitle>
      <ModalParagraph data-testid="delete-account-content-paragraph">
        Are you sure you want to delete the account associated with{' '}
        {clientEmail}?
      </ModalParagraph>
      <WarningText>This action can’t be undone.</WarningText>
      <CheckWrapper>
        <input
          checked={checked}
          data-testid="delete-account-content-check"
          onChange={onCheck}
          type="checkbox"
        />{' '}
        I understand
      </CheckWrapper>
      <ButtonContainer>
        <CancelButton
          data-testid="delete-account-content-cancel-button"
          onClick={onCloseModal}
        >
          Cancel
        </CancelButton>
        <DeleteAccountButton
          data-testid="delete-account-content-delete-button"
          disabled={!checked}
          onClick={onDeleteAccount}
        >
          Delete Account
        </DeleteAccountButton>
      </ButtonContainer>
    </RootWrapper>
  )
}

DeleteAccountModalContent.propTypes = {
  checked: PropTypes.bool.isRequired,
  clientEmail: PropTypes.string.isRequired,
  onCheck: PropTypes.func.isRequired,
  onCloseModal: PropTypes.func,
  onDeleteAccount: PropTypes.func,
}
